/**
 * Products slider
 *
 * @since   1.0.0
 * @package simu
 */

(function($) {
	$(document).ready(function() {

		// gallery (main)
		function initProductsFlickity() {
			var productsFlickity = $('.product-gallery').flickity({

			pageDots: false,
			prevNextButtons: false,
			dragThreshold: 10,
			selectedAttraction: 0.05,
			friction: 0.8,
			});
		}

		if ($('.product-gallery').length > 0) {
			initProductsFlickity();
			$(window).resize(initProductsFlickity);
		}

		// gallery (nav)
		function initProductsNavFlickity() {
			var productsNavFlickity = $('.product-gallery-nav').flickity({

			asNavFor: '.product-gallery',
			pageDots: false,
			prevNextButtons: false,
			cellAlign: 'left',
			dragThreshold: 10,
			selectedAttraction: 0.05,
			friction: 0.8,
			});
		}

		if ($('.product-gallery-nav').length > 0) {
			initProductsNavFlickity();
			//$(window).resize(initProductsNavFlickity);
		}

}); // document.ready
})(jQuery);
